import React from "react";
import styles from "./NoEvent.module.css";

const NoEvent = () => {
  return (
    <main className={`${styles.eventPage}`}>
      <div>NO UPCOMING EVENTS.</div>
    </main>
  );
};

export default NoEvent;
